
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
    cardArea: {
        maxHeight: '53px',
        padding: theme.spacing(1, 1),
        '& span': {
            lineHeight: 1.6
        }
    },
    cardAreaDisabled: {
        opacity: 0.5,
        pointerEvents: 'none'
    }
}))

export default useStyles;